import { Component } from 'react';

import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { MarkdownService } from '../../services/markdown.service';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { UIContext } from '../../services/ui-context';
import { RouteProps } from '../../types/route-types';
import MotiveFrame from '../motive-frames/motive-frame.component';
import styles from './faq-pages.component.module.scss';


/**
 * One FAQ answer page (/faq/<slug>). The question is the page's H1 and comes from the SSR page data
 * (`page_seo.title`, the one writer: the /faq index derives its link text from the same field). The
 * markdown answer starts with the same question as an `<h5>` anchor (the FAQPage schema reads it), so
 * that first heading is dropped from the rendered body when it repeats the H1 (owner 2026-10-11).
 */
export default class FAQPageComponent extends Component<RouteProps> {
    public htmlString;
    public title: string;
    private sub;

    @lazyInject(PageDataProviderService) private pageDataService: PageDataProviderService;
    @lazyInject(MarkdownService) private markdownService: MarkdownService;
    @lazyInject(UIContext) private uiContext: UIContext;

    constructor(props) {
        super(props);
        this.title = props.pageData?.page_seo?.title || '';
        this.htmlString = FAQPageComponent.withoutLeadingQuestion(props.markdownHtml, this.title);
    }

    /** Drops a leading `<h5>question</h5>` whose text equals the H1, so the question is not shown twice. */
    static withoutLeadingQuestion(html: string | undefined, title: string): string | undefined {
        if (!html || !title) return html;
        const m = /^\s*<h5\b[^>]*>([\s\S]*?)<\/h5>\s*/i.exec(html);
        if (!m) return html;
        const norm = (t: string) => t.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
        return norm(m[1]) === norm(title) ? html.slice(m[0].length) : html;
    }

    render() {
        return <MotiveFrame>
            <div className={styles['wrapper']}>
                <div className={styles['main-card']}>
                    {this.title && <h1 className={styles['question']}>{this.title}</h1>}
                    {
                        this.htmlString && <div className={styles['content']} dangerouslySetInnerHTML={{ __html: this.htmlString }}></div>
                    }
                </div>
            </div>
        </MotiveFrame>
    }
}
